import h from 'hyperscript';

export const renderTitle = text => (
    text ?
        <h1 className="embed-title">{ text }</h1> : 
        null
);

export const renderDescription = text => (
    text ?
        <p className="embed-description">{ text }</p> :
        null
);

export const renderLabels = ({ title = '', description = '', position = 'overlay' }) => (
    <figure className="embed-label" data-position={ position }>
        { renderTitle(title) }
        { renderDescription(description) }
    </figure>
)